<template>
  <div v-if="!expandMenu.hidden">
    <el-submenu
      v-if="expandMenuShowList.length"
      :key="expandMenu.id"
      :index="String(expandMenu.id)"
      :class="{
        'parent-link-active': expandMenu.activeIds.includes(selectedMenuId)
      }"
    >
      <template v-slot:title>
        <i
          v-if="expandMenu.icon && time === 1"
          class="iconfont"
          :class="`${expandMenu.icon}`"
        ></i>
        <span v-if="expandMenu.meta">{{ expandMenu.meta.title }}</span>
      </template>

      <sub-menu
        v-for="item in expandMenu.children"
        :key="item.id"
        :expand-menu="item"
        :time="time + 1"
      />
    </el-submenu>

    <!--因为路由经过拍平处理，与目前的菜单展示存在区别，所以无法通过route字段进行标识选中-->
    <el-menu-item
      v-else
      :class="{ 'link-active': expandMenu.activeIds.includes(selectedMenuId) }"
      :index="String(expandMenu.id)"
      @click="handleRouteJump"
    >
      <i
        v-if="expandMenu.icon && time === 1"
        class="iconfont"
        :class="`${expandMenu.icon}`"
      ></i>
      <span slot="title">
        <span>{{ expandMenu.meta.title }}</span>
        <div v-if="expandMenu.meta.isExternal" class="tag">NEW</div>
      </span>
    </el-menu-item>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import WujieVue from 'wujie-vue2'

export default {
  name: 'SubMenu',

  props: {
    expandMenu: {
      type: Object,
      required: true
    },

    time: {
      type: Number,
      required: true
    }
  },

  data() {
    return {}
  },

  computed: {
    selectedMenuId() {
      const lastIndex = this.$route?.meta?.breadcrumb?.length || 1
      return (this.$route?.meta?.breadcrumb || [])[lastIndex - 1]?.id || ''
    },

    expandMenuShowList() {
      if (this.expandMenu?.children?.length) {
        return this.expandMenu.children.filter(route => !route?.meta?.hidden)
      } else {
        return []
      }
    }
  },

  methods: {
    ...mapMutations('router', {
      clearCacheView: 'CLEAR_CACHE_VIEW'
    }),

    handleRouteJump() {
      if (this.expandMenu?.meta.isExternal) {
        window.open(this.expandMenu.path, '_blank')
      } else if (this.expandMenu.name) {
        // 微服务菜单
        if (this.expandMenu?.meta?.isMicro) {
          this.clearCacheView()
          this.$router.push({ name: this.expandMenu.name })
          WujieVue.bus.$emit('menu', this.expandMenu.name)
        } else {
          this.clearCacheView()
          this.$router.push({ name: this.expandMenu.name })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
// 重新设置默认的icon颜色
.iconfont {
  font-size: 20px;
  color: $second-text-color;
  margin-right: 5px;
  vertical-align: -3px;
}

// 设置所有的el-menu-item
::v-deep .el-menu-item,
::v-deep .el-submenu__title {
  position: relative;
  border-left: 2px solid transparent;

  &.is-active {
    color: $text-color;
    background-color: transparent;
  }

  .tag {
    display: inline-block;
    width: 34px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    font-size: 12px;
    color: $danger-color;
    background-color: $danger-third-color;
    margin-left: 3px;
    margin-top: -12px;
    border-radius: 6px 0px 6px 0px;
    transform: scale(0.8);
  }
}

// 调整子路由的左侧间距
::v-deep .el-menu--inline {
  .el-menu-item {
    //padding-left: 45px !important;
  }
}

// 设置默认的hover背景颜色
::v-deep .el-menu-item:hover,
::v-deep .el-submenu__title:hover {
  border-left-color: $primary-background-color;
  background: $primary-background-color;
}

// 子路由active时，父路由菜单样式
.parent-link-active {
  ::v-deep & > .el-submenu__title {
    color: $primary-color !important;

    i {
      color: $primary-color !important;
    }
  }
}

// 子路由active样式
.link-active {
  ::v-deep &.el-menu-item {
    border-left-color: $primary-color;
    background: $primary-background-color;
    color: $primary-color;

    i {
      color: $primary-color;
    }
  }
}
</style>
